import { ComponentStyleConfig } from '@chakra-ui/react';

export const Textarea: ComponentStyleConfig = {
  baseStyle: {
    color: 'textBase',
    borderRadius: 'lg',
    _focus: {
      // TODO: Disable this after making designers agree with focus rings
      boxShadow: 'none',
    },
  },
  sizes: {
    md: {
      px: 3,
      fontSize: 'sm',
    },
  },
  defaultProps: {
    size: 'md',
  },
};
